import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const columnsData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            width: 200,
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
        },
    //     {
    //     title: '项目号',
    //     dataIndex: 'id',
    //     key: 'id',
    //     scopedSlots: {
    //         filterDropdown: 'filterDropdown',
    //         filterIcon: 'filterIcon',
    //         filtered: true,
    //     },
    //     filteredValue: filteredInfo.id || [],
    // },
        {
        title: '合同号',
        dataIndex: 'contractNo',
        key: 'contractNo',
        scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            filtered: true,
            customRender: 'contractNo'
        },
            class:'merge_col_td',
        filteredValue: filteredInfo.contractNo || [],
    },
        {
            title: '类型',
            dataIndex: 'projectType',
            key: 'projectType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'projectType'
            },
            class:'merge_col_td',
            filteredValue: filteredInfo.projectType || [],
        },
        {
            title: '样本数量',
            dataIndex: 'sampleNum',
            key: 'sampleNum',
            scopedSlots: {
                customRender: 'sampleNum'
            },
            class:'merge_col_td',
        },
        {
            title: '样本信息',
            dataIndex: 'sampleInfo',
            key: 'sampleInfo',
            scopedSlots: {
                customRender: 'sampleInfo'
            },
            class:'merge_col_td',
        },
        {
            title: '销售姓名',
            dataIndex: 'salesList',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'salesName'
            },
            class:'merge_col_td',

            filteredValue: filteredInfo.salesName || [],
        }, {
            title: '客户姓名',
            dataIndex: 'customerList',
            key: 'customerName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'customerName'
            },
            class:'merge_col_td',
            filteredValue: filteredInfo.customerName || [],
        },
        {
            title: '下载报告',
            dataIndex: 'reportPath',
            key: 'reportPath',
            class:'merge_col_td',
            scopedSlots: {
                customRender: 'reportPath'
            },
        },
        {
            title: '释放详情',
            dataIndex: 'isHdd',
            key: 'isHdd',
            scopedSlots: {
                filterDropdown: 'filterDropdownDataWay',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'dataWay'
            },
            filteredValue: filteredInfo.isHdd || [],
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 200,
            scopedSlots: {
                customRender: 'remark'
            },
        },

    ]
}
